(function() {
  var CAELIA_SWATCHES = {
    'Buganvilla': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-buganvilla.jpg?v=1784220619',
    'Multicolor': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-multicolor.jpg?v=1784220618',
    'Rojo': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-rojo.jpg?v=1784220619',
    'Rosa': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-rosa.jpg?v=1784220618',
    'Azul': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-azul.jpg?v=1784220618',
    'Verde': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-verde.jpg?v=1784220618',
    'Amarillo': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-amarillo.jpg?v=1784220619',
    'Naranja': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-naranja.jpg?v=1784220619',
    'Marrón': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-marron.jpg?v=1784220618',
    'Marfil': 'https://cdn.shopify.com/s/files/1/0611/6170/1564/files/caelia-swatch-marfil.jpg?v=1784220618'
  };
  var COLOR_ORDER = ['Buganvilla','Multicolor','Rojo','Rosa','Azul','Verde','Amarillo','Naranja','Marrón','Marfil'];

  function injectSwatches() {
    var links = document.querySelectorAll('a[href*="/products/pendientes-caelia"]');
    links.forEach(function(link) {
      var card = link.closest('.card-wrapper');
      if (!card || card.dataset.hanalimaSwatchesInjected) return;
      card.dataset.hanalimaSwatchesInjected = 'true';
      var info = card.querySelector('.card-information') || card.querySelector('.card__information');
      if (!info) return;
      if (info.querySelector('.hanalima-card-swatches')) return;
      var container = document.createElement('div');
      container.className = 'hanalima-card-swatches';
      var baseHref = link.getAttribute('href').split('?')[0];
      COLOR_ORDER.forEach(function(color) {
        var url = CAELIA_SWATCHES[color];
        if (!url) return;
        var a = document.createElement('a');
        a.href = baseHref;
        a.className = 'hanalima-card-swatch';
        a.title = color;
        a.setAttribute('aria-label', 'Color: ' + color);
        var circle = document.createElement('span');
        circle.className = 'hanalima-card-swatch__circle';
        circle.style.backgroundImage = 'url(' + url + ')';
        a.appendChild(circle);
        container.appendChild(a);
      });
      info.appendChild(container);
    });
  }

  var style = document.createElement('style');
  style.textContent =
    /* Swatches Caelia */
    '.hanalima-card-swatches{display:flex;flex-wrap:wrap;gap:8px;margin-top:12px;align-items:center;}'+
    '.hanalima-card-swatch{display:inline-block;padding:2px;border:1px solid transparent;border-radius:50%;transition:border-color .15s ease;text-decoration:none !important;}'+
    '.hanalima-card-swatch:hover{border-color:#1a1a1a;}'+
    '.hanalima-card-swatch__circle{display:block;width:28px;height:28px;border-radius:50%;background-size:cover;background-position:center;background-repeat:no-repeat;box-shadow:0 0 0 .5px rgba(0,0,0,.1) inset;}'+
    /* Ocultar boton en cards de coleccion */
    '.card-wrapper .quick-add,'+
    '.card-wrapper .card__button-wrapper,'+
    '.card-wrapper .quick-add__submit,'+
    '.card-wrapper button.card__button,'+
    '.card-wrapper form[data-type="add-to-cart-form"],'+
    '.card-wrapper modal-opener{display:none !important;}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectSwatches);
  } else {
    injectSwatches();
  }
  document.addEventListener('shopify:section:load', injectSwatches);
  var obs = new MutationObserver(function() { injectSwatches(); });
  obs.observe(document.body, { childList: true, subtree: true });
})();
